import { emit, events } from '@estee/elc-service-bus';

export class FindationButtonClickedUseCase {
    private findationKey: string;

    constructor(findationKey: string) {
        this.findationKey = findationKey;
    }

    public execute = async () => {
        emit(events.FINDATION_BUTTON_CLICKED, {
            findationKey: this.findationKey
        });
    };
}
